import React from "react";
import Coming from "../coming";
import KeynoteCard from "../keynoteCard";
import data from "./data.json";
import "./keynotes.css";

function Keynotes() {
    return (
        <div className="abstract">
            <div className="keynoteCards">
                {
                    data.map(item => {
                        return (
                            <KeynoteCard name={item.name} institute={item.institute} photo={item.photo} />
                        )
                    })
                }
            </div>
        </div>
    )
}

export default Keynotes;